import type { HTMLAttributes, Ref } from "react";
import { cn } from "@/lib/utils";
export function TopBarIsland({
  className,
  isLight = false,
  ref,
  ...props
}: HTMLAttributes<HTMLElement> & {
  isLight?: boolean;
  ref?: Ref<HTMLElement>;
}) {
  return <header ref={ref} className={cn("flex h-10 select-none items-center gap-1 rounded-full bg-surface px-1 text-ink shadow-island [&_input]:select-text", !isLight && "dark", className)} {...props} data-sentry-component="TopBarIsland" data-sentry-source-file="TopBarIsland.tsx" />;
}
export function TopBarDivider({
  className
}: {
  className?: string;
}) {
  return <span className={cn("mx-1 h-4 w-px bg-ink/15", className)} aria-hidden data-sentry-component="TopBarDivider" data-sentry-source-file="TopBarIsland.tsx" />;
}